import React from "react";
import { ClipboardList, SlidersHorizontal, Sparkles, CarFront } from "lucide-react";

const O = ({ children }) => <span className="text-af-orange-core font-semibold">{children}</span>;

const STEPS = [
  {
    n: "01",
    icons: [ClipboardList, SlidersHorizontal],
    t: "Cuéntanos y analizamos tu perfil",
    body: (
      <>
        <p className="text-white/65 text-sm leading-relaxed">
          Responde un formulario de <O>1 minuto</O> con tu perfil económico y la forma en que quieres adquirir tu vehículo.
        </p>
        <p className="text-white/65 text-sm leading-relaxed mt-4">
          Nuestro Business Engine compara en segundos <O>miles de combinaciones</O> entre múltiples instituciones para encontrar las opciones que <O>mejor se adaptan a ti</O>.
        </p>
      </>
    ),
  },
  {
    n: "02",
    icons: [Sparkles],
    t: "Recibe tus alternativas",
    body: (
      <p className="text-white/65 text-sm leading-relaxed">
        Te mostramos únicamente las opciones donde tienes <O>probabilidad real</O> de ser aceptado, con condiciones personalizadas para tu perfil.
      </p>
    ),
  },
  {
    n: "03",
    icons: [CarFront],
    t: "Elige y avanza con confianza",
    body: (
      <p className="text-white/65 text-sm leading-relaxed">
        Decides con información clara y transparente, y comienzas tu proceso con la <O>mejor alternativa para ti</O>.
      </p>
    ),
  },
];

export default function ComoFunciona() {
  return (
    <section id="como-funciona" className="py-16 md:py-20" style={{ background: "var(--af-black)" }}>
      <div className="af-container">
        <div className="text-center mb-12">
          <div className="text-af-orange-core font-display uppercase tracking-widest text-sm mb-2">Cómo funciona</div>
          <h2 className="h-impact text-white text-4xl md:text-5xl">Tu auto en 3 simples pasos</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div key={i} data-testid={`paso-${i}`} className="af-card p-7 relative overflow-hidden">
              <div className="absolute top-4 right-4 font-display font-bold leading-none" style={{ fontSize: 96, color: "rgba(232,93,4,0.14)" }}>{s.n}</div>
              <div className="flex items-center gap-3 relative">
                {s.icons.map((Ic, k) => <Ic key={k} size={40} className="text-af-orange-core" strokeWidth={1.7} />)}
              </div>
              <div className="text-white font-bold text-xl mt-6">{s.t}</div>
              <div className="w-12 h-1 rounded-full mt-3 mb-4" style={{ background: "var(--af-orange-core)" }} />
              {s.body}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
